module.exports = __webpack_public_path__ + "img/tuscaloosa-city-police-logo.c12ea97b.jpg";